import Avatar from 'packages/common/components/Avatar';
import useConfig from 'packages/common/hooks/useConfig';
import React from 'react';
type InviterCodeFooterProps = {
  avatar?: string;
  code: string;
  copyHandler: React.MouseEventHandler;
};

const InviterCodeFooter: React.FC<InviterCodeFooterProps> = ({
  avatar = '',
  code,
  copyHandler
}) => {
  const {
    t
  } = useConfig();
  return <section className="inviter-code-footer-container px-16 py-8 background-color-BGPrimary">
      <section className="content-wrapper px-8 background-color-BGPlaceholderDefault">
        <section className="avatar-wrapper">
          <Avatar size={20} src={avatar} style={{
          background: 'none'
        }} needForceUpdate={false} />
        </section>

        <section className="code-wrapper H4-Regular mx-4 truncate text-color-TextTertiary">
          {code}
        </section>

        <section className="copy-wrapper H4-Bold" onClick={copyHandler}>
          {t('referral_optimize_landing_cta_copy_go')}
        </section>
      </section>
      <style jsx>{`
        .inviter-code-footer-container .content-wrapper {
          height: 30px;
          border-radius: 40px;
          display: flex;
          align-items: center;
        }

        .inviter-code-footer-container .content-wrapper .avatar-wrapper {
          border: 1px solid var(--BGPrimary);
          border-radius: 50%;
          flex: none;
        }

        .inviter-code-footer-container .content-wrapper .code-wrapper {
          flex: 1 1 auto;
        }

        .inviter-code-footer-container .content-wrapper .copy-wrapper {
          flex: none;
          color: #983b07;
          min-width: 80px;
          height: 46px;
          display: flex;
          justify-content: flex-end;
          align-items: center;
        }
      `}</style>
    </section>;
};

export default InviterCodeFooter;